import React, { useCallback, useEffect } from 'react';
import { Container } from '@mui/material';
import { useParams, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { MetaTags } from '../../components/Metatags/Metatags';
import { loadingEventsSelector, selectedEventDetailsSelector, similarEventsSelector } from './selector';
import { EventContainer } from '../../components/ScreenContainer/EventContainer/EventContainer';
import { getEventsDetails } from '../../redux/events/action';
import { Spinner } from '../../components/Loading/Spinner';
import { captureReferralCodeFromUrl } from '../../utils/referralCapture';
import { EmptySearchBlock } from '../../components/EsSidebar/EsSearch/EmptySearchBlock';

const EventDetails = () => {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const event = useSelector(selectedEventDetailsSelector);
    const similarEvents = useSelector(similarEventsSelector);
    const loading = useSelector(loadingEventsSelector);
    const query = Object.fromEntries([...searchParams]);
    const dispatch = useDispatch();
    const { eventId } = params;

    useEffect(() => {
        captureReferralCodeFromUrl();
    }, [searchParams]);

    const handleGetAudition = useCallback(() => {
        if (eventId) {
            dispatch(
                getEventsDetails({
                    slug: eventId,
                    params: !!query && query.search ? '?search=true' : '',
                }),
            );
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [eventId, dispatch]);

    useEffect(() => {
        handleGetAudition();
    }, [handleGetAudition]);

    if (!loading && !event) {
        return (
            <MetaTags title="Event" description="Event not found">
                <Container sx={{ justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
                    <EmptySearchBlock
                        title="No event found"
                        subTitle="The event may have been removed or the link might be incorrect."
                    />
                </Container>
            </MetaTags>
        );
    }

    return (
        <MetaTags title={`Event | ${event?.name!}`} description={event?.description!}>
            <Container maxWidth={false}>
                {loading ? <Spinner /> : event && <EventContainer event={event} similarEvents={similarEvents} />}
            </Container>
        </MetaTags>
    );
};

export { EventDetails };
